import axios from '../../api/httpClient';
import { getApiHeaders } from '../../api/apiHeaders';
import {
    STOCK_ALERT_LIST_ATTEMPT,
    STOCK_ALERT_LIST_SUCCESS,
    STOCK_ALERT_LIST_FAILED,
    STOCK_ALERT_NEW_SUCCESS,
    STOCK_ALERT_NEW_FAILED,
    STOCK_ALERT_REMOVE_SUCCESS,
    STOCK_ALERT_REMOVE_FAILED,
} from '../types/stockAlertTypes';
import { config } from '../../config';

const url_api = config.api.web;

export const loadList = (data) => async (dispatch) => {
    dispatch({ type: STOCK_ALERT_LIST_ATTEMPT });
    try {
        const response = await axios.get(`${url_api}stock_alert/`, {
            params: data.params,
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            dispatch({ type: STOCK_ALERT_LIST_SUCCESS, data: response.data.body });
            return { success: true };
        }
        dispatch({ type: STOCK_ALERT_LIST_FAILED, error: response.data.body });
        return { success: false };
    } catch (error) {
        dispatch({ type: STOCK_ALERT_LIST_FAILED, error: 'try_later' });
        return { success: false };
    }
};

export const newItem = (data) => async (dispatch) => {
    try {
        const response = await axios({
            method: 'post',
            url: `${url_api}stock_alert/`,
            data: data.params,
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            dispatch({ type: STOCK_ALERT_NEW_SUCCESS, item: response.data.body });
            return { success: true, item: response.data.body };
        }
        dispatch({ type: STOCK_ALERT_NEW_FAILED, error: response.data.body });
        return { success: false, error: response.data.body };
    } catch (error) {
        const message = error.response?.data?.body || 'try_later';
        dispatch({ type: STOCK_ALERT_NEW_FAILED, error: message });
        return { success: false, error: message };
    }
};

export const removeItem = (data) => async (dispatch) => {
    try {
        const response = await axios({
            method: 'delete',
            url: `${url_api}stock_alert/`,
            params: data.params,
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            dispatch({ type: STOCK_ALERT_REMOVE_SUCCESS, item: response.data.body });
            return { success: true };
        }
        dispatch({ type: STOCK_ALERT_REMOVE_FAILED, error: response.data.body });
        return { success: false };
    } catch (error) {
        dispatch({ type: STOCK_ALERT_REMOVE_FAILED, error: 'try_later' });
        return { success: false };
    }
};
